export default __webpack_public_path__ + "static/media/mamaTony.c67404c2.png";